import { render, staticRenderFns } from "./baseConfig1.vue?vue&type=template&id=6dc01d90&scoped=true&"
import script from "./baseConfig1.vue?vue&type=script&lang=js&"
export * from "./baseConfig1.vue?vue&type=script&lang=js&"
import style0 from "./baseConfig1.vue?vue&type=style&index=0&id=6dc01d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc01d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc01d90')) {
      api.createRecord('6dc01d90', component.options)
    } else {
      api.reload('6dc01d90', component.options)
    }
    module.hot.accept("./baseConfig1.vue?vue&type=template&id=6dc01d90&scoped=true&", function () {
      api.rerender('6dc01d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/webConfig/baseConfig1.vue"
export default component.exports